import type { DialogFormState, FormFieldValue } from './useDialogForm';

export type FieldErrorProps = { error?: boolean; helperText?: string };

export const useFormErrors = <T extends Record<string, FormFieldValue>>(
  form: DialogFormState<T>,
): {
  errorFor: (key: keyof T) => string | undefined;
  fieldErrorProps: (key: keyof T) => FieldErrorProps;
  clearError: (key: keyof T) => void;
} => {
  const errorFor = (key: keyof T): string | undefined => form.errors[key] ?? undefined;

  const fieldErrorProps = (key: keyof T): FieldErrorProps => {
    const message = errorFor(key);
    return { error: Boolean(message), helperText: message };
  };

  const clearError = (key: keyof T): void => {
    form.clearFieldError(key);
  };

  return { errorFor, fieldErrorProps, clearError };
};
